<app-table-form-container
	[loading]="loading()"
	modelName="Content"
	[showForm]="isFormShowing()"
	(onShowForm)="onShowForm()"
	(onHideForm)="onHideForm()"
>
	<ng-template #tableTemplate>
		<app-cms-table
			[tableKey]="'content-list'"
			[loading]="loading()"
			[rows]="contents()"
			[columns]="columns()"
			[selectedUuid]="editContent()?.uuid"
			[uuidsInProgress]="uuidsInProgress()"
			[enableClickAsEdit]="true"
			(onSelect)="select($event)"
			(onCopy)="copy($event)"
			(onCopyBulk)="copyBulk($event)"
			(onEdit)="edit($event)"
			(onDelete)="delete$($event)"
			(onMoveUp)="moveUp$($event)"
			(onMoveDown)="moveDown$($event)"
		>
			<!-- Header templates (defines order/keys) -->
			<ng-template appHeaderColumn="contentName">Content</ng-template>

			<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
			<ng-template appRowColumn="contentName" let-row>
				<div class="name-column clickable">
					{{ row.active_text.name }}
				</div>
			</ng-template>
		</app-cms-table>
	</ng-template>

	<ng-template #formTemplate>
		<nz-card>
			<app-language-selector (onChange)="onEditLanguageChange($event)"></app-language-selector>
			<app-content-form
				[content]="editContent()"
				[editLanguage]="editLanguage()"
				(onSubmit)="onContentFormSubmit$($event)"
			></app-content-form>
		</nz-card>
	</ng-template>
</app-table-form-container>
